// TODO put finance FAQ resouce key constants
// example: export const FAQ_FINANCE_EXAMPLE = 'FAQ.Finance.Example';
export const LOAN_FAQ_MOSTCOMMONQUESTIONS = 'FAQ.Loan.MostCommonQuestions';
export const LOAN_FAQ_PAYMENTS = 'FAQ.Loan.Payments';
export const LOAN_FAQ_ACCOUNTMANAGEMENT = 'FAQ.Loan.AccountManagement';
export const LOAN_FAQ_PAYOFF = 'FAQ.Loan.Payoff';
export const LOAN_FAQ_SPECIALSITUATIONS = 'FAQ.Loan.SpecialSituations';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTIONS = 'FAQ.Loan.InsuranceAndVehicleProtections';
export const LOAN_FAQ_RELIEF = 'FAQ.Loan.Relief';
export const LOAN_FAQ_WELLSFARGO = 'FAQ.Loan.WellsFargo';

export const LOAN_FAQ_TITLES_QUESTION1 = 'FAQ.Loan.Titles.Question1';
export const LOAN_FAQ_TITLES_ANSWER1_VW = 'FAQ.Loan.Titles.Answer1.VW';
export const LOAN_FAQ_HOMEPAGE_LINK = 'FAQ.Loan.Titles.homepage.Link';

export const LOAN_FAQ_TITLES_QUESTION2 = 'FAQ.Loan.Titles.Question2';
export const LOAN_FAQ_TITLES_ANSWER2_PARAGRAPH_VW = 'FAQ.Loan.Titles.Answer2.VW.Paragraph';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM1_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem1';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM2_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem2';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM3_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem3';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM4_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem4';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM5_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem5';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM6_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem6';
export const LOAN_FAQ_TITLES_ANSWER2_LISTITEM7_VW = 'FAQ.Loan.Titles.Answer2.VW.ListItem7';

export const LOAN_FAQ_TITLES_QUESTION3 = 'FAQ.Loan.Titles.Question3';
export const LOAN_FAQ_TITLES_ANSWER3_PARAGRAPH1_VW = 'FAQ.Loan.Titles.Answer3.VW.Paragraph1';
export const LOAN_FAQ_TITLES_ANSWER3_PARAGRAPH2_VW = 'FAQ.Loan.Titles.Answer3.VW.Paragraph2';

export const LOAN_FAQ_TITLES_QUESTION4 = 'FAQ.Loan.Titles.Question4';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH1_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph1';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH2_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph2';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH3_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph3';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH4_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph4';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH5_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph5';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH6_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph6';
export const LOAN_FAQ_TITLES_ANSWER4_PARAGRAPH7_VW = 'FAQ.Loan.Titles.Answer4.VW.Paragraph7';

export const LOAN_FAQ_TITLES_QUESTION5 = 'FAQ.Loan.Titles.Question5';
export const LOAN_FAQ_TITLES_ANSWER5_PARAGRAPH_VW = 'FAQ.Loan.Titles.Answer5.VW.Paragraph';

export const LOAN_FAQ_TITLES_QUESTION9 = 'FAQ.Loan.Titles.Question9';
export const LOAN_FAQ_TITLES_ANSWER9_PARAGRAPH1_VW = 'FAQ.Loan.Titles.Answer9.VW.Paragraph1';
export const LOAN_FAQ_TITLES_ANSWER9_PARAGRAPH2_VW = 'FAQ.Loan.Titles.Answer9.VW.Paragraph2';

export const LOAN_FAQ_TITLES_QUESTION10 = 'FAQ.Loan.Titles.Question10';
export const LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH1_VW = 'FAQ.Loan.Titles.Answer10.VW.Paragraph1';
export const LOAN_FAQ_TITLES_ANSWER10_BOLDTEXT_VW = 'FAQ.Loan.Titles.Answer10.VW.boldtext';
export const LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH2_VW = 'FAQ.Loan.Titles.Answer10.VW.Paragraph2';
export const LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH2_AUDI = 'FAQ.Loan.Titles.Answer10.VW.Paragraph2';
export const LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH3_VW = 'FAQ.Loan.Titles.Answer10.VW.Paragraph3';
export const LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH4_VW = 'FAQ.Loan.Titles.Answer10.Paragraph4.VW';
export const LOAN_FAQ_TITLES_ANSWER10_PARAGRAPH4_AUDI = 'FAQ.Loan.Titles.Answer10.Paragraph4.Audi';

export const LOAN_FAQ_TITLES_QUESTION11 = 'FAQ.Loan.Titles.Question11';
export const LOAN_FAQ_TITLES_ANSWER11_PARAGRAPH_VW = 'FAQ.Loan.Titles.Answer11.VW.Paragraph';

export const LOAN_FAQ_PAYMENTS_QUESTION17 = 'FAQ.Loan.Payments.Question17';
export const LOAN_FAQ_PAYMENTS_ANSWER17_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer17.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER17_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer17.VW.Paragraph2';

export const LOAN_FAQ_PAYMENTS_QUESTION18 = 'FAQ.Loan.Payments.Question18';
export const LOAN_FAQ_PAYMENTS_ANSWER18_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer18.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER18_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer18.VW.Paragraph2';

export const LOAN_FAQ_PAYMENTS_QUESTION19 = 'FAQ.Loan.Payments.Question19';
export const LOAN_FAQ_PAYMENTS_ANSWER19_PARAGRAPH_VW = 'FAQ.Loan.Payments.Answer19.VW.Paragraph';

export const LOAN_FAQ_PAYMENTS_QUESTION20 = 'FAQ.Loan.Payments.Question20';
export const LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer20.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer20.VW.Paragraph2';
export const LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH3_VW = 'FAQ.Loan.Payments.Answer20.VW.Paragraph3';
export const LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM1_VW = 'FAQ.Loan.Payments.Answer20.VW.ListItem1';
export const LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM2_VW = 'FAQ.Loan.Payments.Answer20.VW.ListItem2';
export const LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH4_VW = 'FAQ.Loan.Payments.Answer20.VW.Paragraph4';
export const LOAN_FAQ_PAYMENTS_ANSWER20_PARAGRAPH4_AUDI = 'FAQ.Loan.Payments.Answer20.Audi.Paragraph4';
export const LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM3_VW = 'FAQ.Loan.Payments.Answer20.VW.ListItem3';
export const LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM4_VW = 'FAQ.Loan.Payments.Answer20.VW.ListItem4';
export const LOAN_FAQ_PAYMENTS_ANSWER20_LISTITEM5_VW = 'FAQ.Loan.Payments.Answer20.VW.ListItem5';

export const LOAN_FAQ_PAYMENTS_QUESTION22 = 'FAQ.Loan.Payments.Question22';
export const LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer22.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer22.Paragraph2.VW';
export const LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH2_AUDI = 'FAQ.Loan.Payments.Answer22.Paragraph2.Audi';
export const LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH3_VW = 'FAQ.Loan.Payments.Answer22.VW.Paragraph3';
export const LOAN_FAQ_PAYMENTS_ANSWER22_PARAGRAPH4_VW = 'FAQ.Loan.Payments.Answer22.VW.Paragraph4';

export const LOAN_FAQ_PAYMENTS_QUESTION23 = 'FAQ.Loan.Payments.Question23';
export const LOAN_FAQ_PAYMENTS_ANSWER23_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer23.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM1_VW = 'FAQ.Loan.Payments.Answer23.VW.ListItem1';
export const LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM2_VW = 'FAQ.Loan.Payments.Answer23.VW.ListItem2';
export const LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM3_VW = 'FAQ.Loan.Payments.Answer23.ListItem3.VW';
export const LOAN_FAQ_PAYMENTS_ANSWER23_LISTITEM3_AUDI = 'FAQ.Loan.Payments.Answer23.ListItem3.Audi';
export const LOAN_FAQ_PAYMENTS_ANSWER23_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer23.VW.Paragraph2';
export const LOAN_FAQ_PAYMENTS_ANSWER23_PARAGRAPH3_VW = 'FAQ.Loan.Payments.Answer23.VW.Paragraph3';

export const LOAN_FAQ_PAYMENTS_QUESTION24 = 'FAQ.Loan.Payments.Question24';
export const LOAN_FAQ_PAYMENTS_ANSWER24_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer24.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER24_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer24.VW.Paragraph2';

export const LOAN_FAQ_PAYMENTS_QUESTION25 = 'FAQ.Loan.Payments.Question25';
export const LOAN_FAQ_PAYMENTS_ANSWER25_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer25.VW.Paragraph1';

export const LOAN_FAQ_PAYMENTS_QUESTION26 = 'FAQ.Loan.Payments.Question26';
export const LOAN_FAQ_PAYMENTS_ANSWER26_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer26.VW.Paragraph1';
export const LOAN_FAQ_PAYMENTS_ANSWER26_PARAGRAPH2_VW = 'FAQ.Loan.Payments.Answer26.VW.Paragraph2';

export const LOAN_FAQ_PAYMENTS_QUESTION27 = 'FAQ.Loan.Payments.Question27';
export const LOAN_FAQ_PAYMENTS_ANSWER27_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer27.VW.Paragraph1';

export const LOAN_FAQ_PAYMENTS_QUESTION28_VW = 'FAQ.Loan.Payments.vw.Question28';
export const LOAN_FAQ_PAYMENTS_QUESTION28_AUDI = 'FAQ.Loan.Payments.Audi.Question28';

export const LOAN_FAQ_PAYMENTS_ANSWER28_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer28.VW.Paragraph1';

export const LOAN_FAQ_PAYMENTS_QUESTION29 = 'FAQ.Loan.Payments.Question29';
export const LOAN_FAQ_PAYMENTS_ANSWER29_PARAGRAPH1_VW = 'FAQ.Loan.Payments.Answer29.VW.Paragraph1';

export const LOAN_FAQ_ACCOUNTS_QUESTION30 = 'FAQ.Loan.Accounts.Question30';
export const LOAN_FAQ_ACCOUNTS_ANSWER30_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer30.VW.Paragraph1';

export const LOAN_FAQ_ACCOUNTS_QUESTION31 = 'FAQ.Loan.Accounts.Question31';
export const LOAN_FAQ_ACCOUNTS_ANSWER31_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer31.VW.Paragraph1';
export const LOAN_FAQ_ACCOUNTS_ANSWER31_PARAGRAPH2_VW = 'FAQ.Loan.Accounts.Answer31.VW.Paragraph2';

export const LOAN_FAQ_ACCOUNTS_QUESTION32 = 'FAQ.Loan.Accounts.Question32';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer32.VW.Paragraph1';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_PARAGRAPH1_AUDI = 'FAQ.Loan.Accounts.Answer32.Audi.Paragraph1';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM1_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem1';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM2_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem2';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM3_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem3';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM4_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem4';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM5_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem5';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM6_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem6';
export const LOAN_FAQ_ACCOUNTS_ANSWER32_LISTITEM7_VW = 'FAQ.Loan.Accounts.Answer32.VW.ListItem7';

export const LOAN_FAQ_ACCOUNTS_QUESTION33_VW = 'FAQ.Loan.Accounts.vw.Question33';
export const LOAN_FAQ_ACCOUNTS_QUESTION33_AUDI = 'FAQ.Loan.Accounts.Audi.Question33';
export const LOAN_FAQ_ACCOUNTS_ANSWER33_PARAGRAPH1 = 'FAQ.Loan.Accounts.Answer33.Paragraph1';

export const LOAN_FAQ_ACCOUNTS_QUESTION34 = 'FAQ.Loan.Accounts.Question34';
export const LOAN_FAQ_ACCOUNTS_ANSWER34_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer34.VW.Paragraph1';

export const LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer35.VW.Paragraph1';
export const LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH2_VW = 'FAQ.Loan.Accounts.Answer35.VW.Paragraph2';
export const LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH3_VW = 'FAQ.Loan.Accounts.Answer35.VW.Paragraph3';
export const LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH4_VW = 'FAQ.Loan.Accounts.Answer35.VW.Paragraph4';
export const LOAN_FAQ_ACCOUNTS_ANSWER35_PARAGRAPH5_VW = 'FAQ.Loan.Accounts.Answer35.VW.Paragraph5';

//
export const LOAN_FAQ_ACCOUNTS_QUESTION37 = 'FAQ.Loan.Accounts.Question37';
export const LOAN_FAQ_ACCOUNTS_ANSWER37_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer37.VW.Paragraph1';
export const LOAN_FAQ_ACCOUNTS_ANSWER37_PARAGRAPH2_AUDI = 'FAQ.Loan.Accounts.Answer37.Audi.Paragraph1';

export const LOAN_FAQ_ACCOUNTS_ANSWER37_PARAGRAPH2 = 'FAQ.Loan.Accounts.Answer37.VW.Paragraph2';

export const LOAN_FAQ_ACCOUNTS_QUESTION38 = 'FAQ.Loan.Accounts.Question38';
export const LOAN_FAQ_ACCOUNTS_ANSWER38_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer38.Paragraph1.VW';
export const LOAN_FAQ_ACCOUNTS_ANSWER38_PARAGRAPH1_AUDI = 'FAQ.Loan.Accounts.Answer38.Paragraph1.Audi';

export const LOAN_FAQ_ACCOUNTS_QUESTION39 = 'FAQ.Loan.Accounts.Question39';
export const LOAN_FAQ_ACCOUNTS_ANSWER39_VW_PARAGRAPH1 = 'FAQ.Loan.Accounts.Answer39.VW.Paragraph1';
export const LOAN_FAQ_ACCOUNTS_ANSWER39_VW_PARAGRAPH2 = 'FAQ.Loan.Accounts.Answer39.VW.Paragraph2';

export const LOAN_FAQ_ACCOUNTS_QUESTION40 = 'FAQ.Loan.Accounts.Question40';
export const LOAN_FAQ_ACCOUNTS_ANSWER40_VW_PARAGRAPH1 = 'FAQ.Loan.Accounts.Answer40.VW.Paragraph1';

export const LOAN_FAQ_ACCOUNTS_QUESTION41_VW = 'FAQ.Loan.Accounts.VW.Question41';
export const LOAN_FAQ_ACCOUNTS_QUESTION41_AUDI = 'FAQ.Loan.Accounts.Audi.Question41';

export const LOAN_FAQ_ACCOUNTS_ANSWER41_PARAGRAPH1_VW = 'FAQ.Loan.Accounts.Answer41.Paragraph1.VW';
export const LOAN_FAQ_ACCOUNTS_ANSWER41_PARAGRAPH1_AUDI = 'FAQ.Loan.Accounts.Answer41.Paragraph1.Audi';

export const LOAN_FAQ_PAYOFFS_QUESTION42 = 'FAQ.Loan.Payoffs.Question42';
export const LOAN_FAQ_PAYOFFS_ANSWER42_VW_PARAGRAPH1 = 'FAQ.Loan.Payoffs.Answer42.VW.Paragraph1';
export const LOAN_FAQ_PAYOFFS_ANSWER42_VW_PARAGRAPH2 = 'FAQ.Loan.Payoffs.Answer42.VW.Paragraph2';
export const LOAN_FAQ_PAYOFFS_ANSWER42_VW_PARAGRAPH3 = 'FAQ.Loan.Payoffs.Answer42.VW.Paragraph3';
export const LOAN_FAQ_PAYOFFS_ANSWER42_VW_PARAGRAPH4 = 'FAQ.Loan.Payoffs.Answer42.VW.Paragraph4';

export const LOAN_FAQ_PAYOFFS_QUESTION43 = 'FAQ.Loan.Payoffs.Question43';
export const LOAN_FAQ_PAYOFFS_ANSWER43_VW_PARAGRAPH1 = 'FAQ.Loan.Payoffs.Answer43.VW.Paragraph1';

export const LOAN_FAQ_PAYOFFS_QUESTION44 = 'FAQ.Loan.Payoffs.Question44';
export const LOAN_FAQ_PAYOFFS_ANSWER44_VW_PARAGRAPH1 = 'FAQ.Loan.Payoffs.Answer44.VW.Paragraph1';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION45 = 'FAQ.Loan.SpecialSituatons.Question45';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_VW_PARAGRAPH1 = 'FAQ.Loan.SpecialSituatons.Answer45.VW.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_PARAGRAPH2_VW = 'FAQ.Loan.SpecialSituatons.Answer45.VW.Paragraph2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_PARAGRAPH2_AUDI = 'FAQ.Loan.SpecialSituatons.Answer45.Audi.Paragraph2';

export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER45_VW_PARAGRAPH3 = 'FAQ.Loan.SpecialSituatons.Answer45.VW.Paragraph3';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION46 = 'FAQ.Loan.SpecialSituatons.Question46';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER46_VW_PARAGRAPH1 = 'FAQ.Loan.SpecialSituatons.Answer46.VW.Paragraph1';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION47 = 'FAQ.Loan.SpecialSituatons.Question47';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_PARAGRAPH1 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM1 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM2 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM3 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem3';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM4 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem4';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM5 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem5';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM6 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem6';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM7 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem7';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_PARAGRAPH2 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.Paragraph2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_PARAGRAPH3 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.Paragraph3';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_PARAGRAPH4 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.Paragraph4';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM8 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem8';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM9 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem9';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM10 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem10';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_SUBLISTITEM1 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.SubListItem1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_SUBLISTITEM2 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.SubListItem2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_PARAGRAPH5 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.Paragraph5';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM11 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem11';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM12 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem12';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM13 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem13';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM14 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem14';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM15 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem15';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER47_VW_LISTITEM16 = 'FAQ.Loan.SpecialSituatons.Answer47.VW.ListItem16';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION48 = 'FAQ.Loan.SpecialSituatons.Question48';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_PARAGRAPH1_VW = 'FAQ.Loan.SpecialSituatons.Answer48.VW.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_PARAGRAPH1_AUDI = 'FAQ.Loan.SpecialSituatons.Answer48.Audi.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_VW_PARAGRAPH2 = 'FAQ.Loan.SpecialSituatons.Answer48.VW.Paragraph2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_PARAGRAPH3_VW = 'FAQ.Loan.SpecialSituatons.Answer48.VW.Paragraph3';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER48_PARAGRAPH3_AUDI = 'FAQ.Loan.SpecialSituatons.Answer48.Audi.Paragraph3';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION49 = 'FAQ.Loan.SpecialSituatons.Question49';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_VW_PARAGRAPH1 = 'FAQ.Loan.SpecialSituatons.Answer49.VW.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_PARAGRAPH2_VW = 'FAQ.Loan.SpecialSituatons.Answer49.VW.Paragraph2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_PARAGRAPH2_AUDI = 'FAQ.Loan.SpecialSituatons.Answer49.Audi.Paragraph2';

export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_VW_PARAGRAPH3 = 'FAQ.Loan.SpecialSituatons.Answer49.VW.Paragraph3';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER49_VW_PARAGRAPH4 = 'FAQ.Loan.SpecialSituatons.Answer49.VW.Paragraph4';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION50 = 'FAQ.Loan.SpecialSituatons.Question50';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_PARAGRAPH1 = 'FAQ.Loan.SpecialSituatons.Answer50.VW.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM1 = 'FAQ.Loan.SpecialSituatons.Answer50.VW.ListItem1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM2 = 'FAQ.Loan.SpecialSituatons.Answer50.VW.ListItem2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM3 = 'FAQ.Loan.SpecialSituatons.Answer50.VW.ListItem3';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_LISTITEM4 = 'FAQ.Loan.SpecialSituatons.Answer50.VW.ListItem4';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_VW_PARAGRAPH2 = 'FAQ.Loan.SpecialSituatons.Answer50.VW.Paragraph2';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_PARAGRAPH3_VW = 'FAQ.Loan.SpecialSituatons.Answer50.Paragraph3.VW';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER50_PARAGRAPH3_AUDI = 'FAQ.Loan.SpecialSituatons.Answer50.Paragraph3.Audi';

export const LOAN_FAQ_SPECIALSITUATIONS_QUESTION51 = 'FAQ.Loan.SpecialSituatons.Question51';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER51_VW_PARAGRAPH1 = 'FAQ.Loan.SpecialSituatons.Answer51.VW.Paragraph1';
export const LOAN_FAQ_SPECIALSITUATIONS_ANSWER51_VW_PARAGRAPH2 = 'FAQ.Loan.SpecialSituatons.Answer51.VW.Paragraph2';

export const LOAN_FAQ_DISASTERRELIEF_QUESTION52 = 'FAQ.Loan.DisasterRelief.Question52';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER52_VW_PARAGRAPH1 = 'FAQ.Loan.DisasterRelief.Answer52.VW.Paragraph1';

export const LOAN_FAQ_DISASTERRELIEF_QUESTION53 = 'FAQ.Loan.DisasterRelief.Question53';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER53_VW_PARAGRAPH1 = 'FAQ.Loan.DisasterRelief.Answer53.VW.Paragraph1';

export const LOAN_FAQ_DISASTERRELIEF_QUESTION54 = 'FAQ.Loan.DisasterRelief.Question54';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER54_VW_PARAGRAPH1 = 'FAQ.Loan.DisasterRelief.Answer54.VW.Paragraph1';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER54_VW_PARAGRAPH2 = 'FAQ.Loan.DisasterRelief.Answer54.VW.Paragraph2';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER54_VW_PARAGRAPH3 = 'FAQ.Loan.DisasterRelief.Answer54.VW.Paragraph3';

export const LOAN_FAQ_DISASTERRELIEF_QUESTION55 = 'FAQ.Loan.DisasterRelief.Question55';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER55_VW_PARAGRAPH1 = 'FAQ.Loan.DisasterRelief.Answer55.VW.Paragraph1';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER55_VW_PARAGRAPH2 = 'FAQ.Loan.DisasterRelief.Answer55.VW.Paragraph2';
export const LOAN_FAQ_DISASTERRELIEF_ANSWER55_VW_PARAGRAPH3 = 'FAQ.Loan.DisasterRelief.Answer55.VW.Paragraph3';

export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_QUESTION56 = 'FAQ.Loan.InsuranceAndVehicleProtection.Question56';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER56_PARAGRAPH1_VW =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer56.VW.Paragraph1';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER56_PARAGRAPH1_AUDI =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer56.Audi.Paragraph1';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER56_VW_PARAGRAPH2 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer56.VW.Paragraph2';

export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_QUESTION57_VW =
  'FAQ.Loan.InsuranceAndVehicleProtection.vw.Question57';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_QUESTION57_AUDI =
  'FAQ.Loan.InsuranceAndVehicleProtection.Audi.Question57';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER57_VW_PARAGRAPH1 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer57.VW.Paragraph1';

export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER57_VW_PARAGRAPH3 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer57.VW.Paragraph3';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER57_VW_PARAGRAPH4 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer57.VW.Paragraph4';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER57_VW_PARAGRAPH5 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer57.VW.Paragraph5';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER57_VW_PARAGRAPH6 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer57.VW.Paragraph6';

export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_QUESTION58 = 'FAQ.Loan.InsuranceAndVehicleProtection.Question58';
export const LOAN_FAQ_INSURANCEANDVEHICLEPROTECTION_ANSWER58_VW_PARAGRAPH1 =
  'FAQ.Loan.InsuranceAndVehicleProtection.Answer58.VW.Paragraph1';

export const LOAN_FAQ_WELLSFARGO_QUESTION59 = 'FAQ.Loan.WellsFargo.Question59';
export const LOAN_FAQ_WELLSFARGO_ANSWER59_VW_PARAGRAPH1 = 'FAQ.Loan.WellsFargo.Answer59.VW.Paragraph1';

export const LOAN_FAQ_WELLSFARGO_QUESTION60 = 'FAQ.Loan.WellsFargo.Question60';
export const LOAN_FAQ_WELLSFARGO_ANSWER60_VW_PARAGRAPH1 = 'FAQ.Loan.WellsFargo.Answer60.VW.Paragraph1';
export const LOAN_FAQ_WELLSFARGO_ANSWER60_VW_PARAGRAPH2 = 'FAQ.Loan.WellsFargo.Answer60.VW.Paragraph2';
export const LOAN_FAQ_WELLSFARGO_ANSWER60_VW_PARAGRAPH3 = 'FAQ.Loan.WellsFargo.Answer60.VW.Paragraph3';
export const LOAN_FAQ_WELLSFARGO_ANSWER60_VW_PARAGRAPH4 = 'FAQ.Loan.WellsFargo.Answer60.VW.Paragraph4';
export const LOAN_FAQ_WELLSFARGO_ANSWER60_VW_PARAGRAPH5 = 'FAQ.Loan.WellsFargo.Answer60.VW.Paragraph5';

export const LOAN_FAQ_WELLSFARGO_QUESTION61 = 'FAQ.Loan.WellsFargo.Question61';
export const LOAN_FAQ_WELLSFARGO_ANSWER61_VW_PARAGRAPH1 = 'FAQ.Loan.WellsFargo.Answer61.VW.Paragraph1';
export const LOAN_FAQ_WELLSFARGO_ANSWER61_VW_PARAGRAPH2 = 'FAQ.Loan.WellsFargo.Answer61.VW.Paragraph2';
export const LOAN_FAQ_WELLSFARGO_ANSWER61_VW_PARAGRAPH3 = 'FAQ.Loan.WellsFargo.Answer61.VW.Paragraph3';
export const LOAN_FAQ_WELLSFARGO_ANSWER61_VW_PARAGRAPH4 = 'FAQ.Loan.WellsFargo.Answer61.VW.Paragraph4';
export const LOAN_FAQ_WELLSFARGO_ANSWER61_VW_PARAGRAPH5 = 'FAQ.Loan.WellsFargo.Answer61.VW.Paragraph5';

export const LOAN_FAQ_PAYMENTS_ANSWER22_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER22_LINK1_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER22_LINK2_VW = 'LOAN_FAQ_PAYMENTS_ANSWER22_LINK2_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER22_LINK3_VW = 'LOAN_FAQ_PAYMENTS_ANSWER22_LINK3_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER22_LINK4_VW = 'LOAN_FAQ_PAYMENTS_ANSWER22_LINK4_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER23_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER23_LINK1_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER23_LINK2_VW = 'LOAN_FAQ_PAYMENTS_ANSWER23_LINK2_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER23_LINK3_VW = 'LOAN_FAQ_PAYMENTS_ANSWER23_LINK3_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER24_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER24_LINK1_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER24_LINK2_VW = 'LOAN_FAQ_PAYMENTS_ANSWER24_LINK2_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER25_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER25_LINK1_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER26_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER26_LINK1_VW';
export const LOAN_FAQ_PAYMENTS_ANSWER26_LINK2_VW = 'LOAN_FAQ_PAYMENTS_ANSWER26_LINK2_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER27_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER27_LINK1_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER28_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER28_LINK1_VW';

export const LOAN_FAQ_PAYMENTS_ANSWER29_LINK1_VW = 'LOAN_FAQ_PAYMENTS_ANSWER29_LINK1_VW';
